<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">
      <!--site header begins-->
      <section class="admin-content">
        <div class="container">
         

          <div class="col-md-12 my-8">
            <button
              type="button"
              :class="buttoncolor.formal"
              @click="showFormal"
            >
              Formal <i class="fe fe-list"></i>
            </button>
            <button
              type="button"
              :class="buttoncolor.informal"
              @click="showInformal"
            >
              Informal <i class="fe fe-grid"></i>
            </button>
          </div>

          <div class="" v-show="formal_S">
            <FormalSector />
          </div>

          <div class="" v-show="informal_S">
            <InformalSector />
          </div>

          <div class="col-md-12" style="margin-top: 20px">
            <EncounterbyLGA />
          </div>

          <div class="col-md-12" style="margin-top: 20px">
            <EncounterbyDiagnosis />
          </div>

          <div class="row" style="margin-top: 20px">
            <div class="col-md-12">
              <ClaimsDate />
            </div>

            <div class="col-md-12">
              <EncountersbyDate />
            </div>
            <div class="col-md-4">
              <ClaimsCategory />
            </div>
            <div class="col-md-4">
              <ReferralCategory />
            </div>
            <div class="col-md-4">
              <ChangeProviderCategory />
            </div>
          </div>

          
          <!-- <ClientDataDashboard /> -->
        </div>
        <Footer />
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Footer from "@/views/Footer.vue";
import InformalSector from "@/views/shis/components/InformalSector.vue";
import FormalSector from "@/views/shis/components/FormalSector.vue";
import ClaimsDate from "@/views/shis/components/ClaimsbyDate";
import EncounterbyLGA from "@/views/shis/components/EncounterbyLGA";
import EncounterbyDiagnosis from "@/views/shis/components/EncounterbyDiagnosis";
import EncountersbyDate from "@/views/shis/components/EncountersbyDate";
import ClaimsCategory from "@/views/shis/components/ClaimStatusChart";
import ReferralCategory from "@/views/shis/components/ReferralStatusChart";
import ChangeProviderCategory from "@/views/shis/components/ChangeProviderStatusChart";

export default {
  components: {
    Navbar,
    InformalSector,
    FormalSector,
    Footer,
    ClaimsDate,
    ClaimsCategory,
    ReferralCategory,
    ChangeProviderCategory,
    EncountersbyDate,
    EncounterbyLGA,
    EncounterbyDiagnosis,
  },

  data() {
    return {
      user: null,
      formal_S: false,
      informal_S: true,
      mydata: "",
      auth_user: "",
      providers: "",
      trial_date: "2/2/2023",
      total_clients: "",
      claims: "",
      offlineclients: [],
      employees: "",
      plans: "",
      tpas: "",
      buttoncolor: {
        informal: "btn btn-success",
        formal: "btn btn-default",
      },
    };
  },
  beforeMount() {},
  computed: {
    //
  },

  methods: {
    showFormal() {
      this.formal_S = true;
      this.informal_S = false;
      this.buttoncolor.formal = "btn btn-success";
      this.buttoncolor.informal = "btn btn-default";
    },
    showInformal() {
      this.formal_S = false;
      this.informal_S = true;
      this.buttoncolor.informal = "btn btn-success";
      this.buttoncolor.formal = "btn btn-default";
    },
  },
  created() {},
};
</script>
<style lang="css" scoped>
.spacer-top {
  margin-top: 10px;
}
</style>
